import { render, staticRenderFns } from "./products-result-item.vue?vue&type=template&id=aeb23008&"
import script from "./products-result-item.vue?vue&type=script&lang=js&"
export * from "./products-result-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports